import ColumnSet from '@/components/grid/columns/column-set';
import store from '@/store';
import auth from '@/common/auth/auth';

export default new ColumnSet({
    id: 'gateway-accounts-list',
    store,
    version: 3,
    defaultColumns: [
        {
            name: 'id',
            type: 'link',
            to: ({fields}) => ({
                name: 'gateway-account-details',
                params: {
                    id: fields.id,
                },
            }),
            predicate: auth.$pages['update-data-export'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            sortable: true,
            sticky: true,
        },
        {
            name: 'gatewayName',
            header: 'Gateway',
            sortable: true,
        },
        {
            name: 'acceptedCurrencies',
            header: 'Currencies',
        },
        {
            name: 'method',
            type: 'badge',
        },
        {
            name: 'status',
            sortable: true,
            type: 'badge',
            map: {
                active: 'positive',
                pending: 'warning',
            },
        },
        {
            name: 'paymentCardSchemes',
            type: 'payment-card',
        },
    ],
    otherColumns: [
        {
            name: 'organizationId',
            style: {truncate: true},
        },
        {
            name: 'threeDSecure',
            header: '3D Secure',
        },
        {
            name: 'dccMarkup',
            header: 'DCC Markup',
        },
        {
            name: 'excludedDccQuoteCurrencies',
            header: 'Excluded DCC Quote Currencies',
        },
        {
            name: 'dccForceCurrency',
            header: 'DCC Force Currency',
        },
        {
            name: 'approvalWindowTtl',
            header: 'Approval Window TTL',
        },
        {
            name: 'acquirerName',
        },
        {
            name: 'createdTime',
            header: 'Creation Time',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'updatedTime',
            header: 'Last Update Time',
            type: 'datetime',
            sortable: true,
        },
    ],
});
